export enum DeliveryType {
    Min90 = '90MIN',
    Today = 'TODAY',
    Timeslot = 'TIMESLOT',
    Instant = 'INSTANT',
    Unknown = '',
}
